import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconCalendar = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1M7 6H6a1 1 0 0 0-1 1v3h14V7a1 1 0 0 0-1-1h-1v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0zm12 6H5v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1zM8 13a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V14a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V14a1 1 0 0 1 1-1m4 0a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V14a1 1 0 0 1 1-1m-8 4a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1"
            clipRule="evenodd"
        />
    </svg>
);
